<template>
  <div>
    <div class="d-flex justify-end">
      <v-chip
        v-if="items && items.length > 0"
        class="mb-2"
        label
        small
        color="primary"
        @click="copy"
      >
        {{ copied ? 'Copied!' : 'Copy' }}
      </v-chip>
    </div>
    <v-expansion-panels
      v-if="items && items.length > 0"
    >
      <v-expansion-panel
        v-for="(item) in items"
        :key="item.question"
      >
        <v-expansion-panel-header>
          {{ item.question }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          {{ item.answer }}
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <span
      v-else
      class="caption font-italic"
    >
      No FAQ Schema found
    </span>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
  },
  data: () => ({
    copied: false,
  }),
  methods: {
    copy() {
      const content = this.items.map(({ question, answer }) => ` - ${question}\n${answer}\n`).join("\n");
      navigator.clipboard.writeText(content);
      this.copied = true;
      setTimeout(() => this.copied = false, 1000);
    }
  }
}
</script>
